import {
  IAdvancedRulesClient,
  IAdvancedRulesServer,
  IFieldLevelRuleServer,
  IForm,
  IFormLockedBy,
  ISlotSetting,
  ITimeOfDayConfig,
  visibilityType,
} from "@common/redux/formBuilder/interface";
import { ICurrencyFieldConfigurationServer } from "@presentation/FormBuilder/components/FormCurrencyField/interface";
import { IDatepickerFieldConfigurationServer } from "@presentation/FormBuilder/components/FormDateField/interface";
import { IDropdownFieldConfigurationServer } from "@presentation/FormBuilder/components/FormDropdownField/interface";
import { IFileUploadFieldConfigurationServer } from "@presentation/FormBuilder/components/FormFileUploadField/interface";
import { ILinearScalingFieldConfigurationServer } from "@presentation/FormBuilder/components/FormLinearScaleField/interface";
import { IMultiChoiceFieldConfigurationServer } from "@presentation/FormBuilder/components/FormMultipleChoicesField/interface";
import { ITextAreaFieldConfigurationServer } from "@presentation/FormBuilder/components/FormTextAreaField/interface";
import {
  IMaskedField,
  ITextInputFieldConfigurationServer,
} from "@presentation/FormBuilder/components/FormTextInputField/interface";
import { INumberInputFieldConfigurationServer } from "@presentation/FormBuilder/components/FormNumberInputField/interface";
import { ITimepickerFieldConfigurationServer } from "@presentation/FormBuilder/components/FormTimePickerField/interface";
import { IDateTimepickerFieldConfigurationServer } from "@presentation/FormBuilder/components/FormDateTimePickerField/interface";
import { IRatingFieldConfigurationServer } from "@presentation/FormBuilder/components/FormRatingField/interface";
import { ICalculativeInputFieldConfigurationServer } from "@presentation/FormBuilder/components/FormCalculativeInputField/interface";
import { IDescriptionFieldConfigurationServer } from "@presentation/FormBuilder/components/DescriptionField/interface";
import { IPaymentInputFieldConfigurationServer } from "@presentation/FormBuilder/components/FormPaymentInputField/interface";
import { ICheckBoxFieldConfigurationServer } from "@presentation/FormBuilder/components/FormCheckboxField/interface";
import { ISectionFieldConfigurationServer } from "@presentation/FormBuilder/components/FormSectionOverviewComponent/utils";
import { ISequenceFieldConfigurationServer } from "@presentation/FormBuilder/components/FormSequenceField/interface";
import {
  ICondition,
  IFilterCondition,
  IFormLookUpConfigurationServer,
} from "@presentation/FormBuilder/components/FormLookupField/interface";
import { descriptionType } from "@presentation/FormBuilder/components/utils";
import { IGeolocationConfigurationServer } from "@presentation/FormBuilder/components/FormGeolocationField/interface";
import { IWorkflowServer } from "../formSubmission/interface";
import { IPincodeFieldConfigurationServer } from "@presentation/FormBuilder/components/FormPincodeField/interface";
import { IFieldLevelRuleConditionServer } from "@presentation/GroupedFilterContainer/interface";
import { ITimeSlotFieldConfigurationServer } from "@presentation/FormBuilder/components/FormTimeSlot/interface";
import { aggregateFuntionEnum } from "../formBuilder/utils";
import { ITemplate } from "@presentation/Templates/interface";
import { OtpMethodValue } from "@presentation/Forms/Components/FormSetting/FormValidation/utils";
import { IOption } from "@erelego/design-system/components/atoms/DropdownSelect";

export interface IFormsState {
  formsMap: IFormsMap;
  rulesMap: IRulesMap;
  workflowMap: IWorkflowMap;
  infographicMap: IInfographicMap;
  dashboardDataMap: IDashboardDataMap;
  submissionCountMap: ISubmissionCountMap;
  loaders: ILoaders;
  errors: IErrors;
  formsData: IFormsData;
  customPermission: ICustomPermission;
}
export interface IWorkflowMap {
  [formId: string]: IWorkflowServer[];
}
export interface ICustomPermission {
  applicationId?: string;
  id?: string;
  clientId?: string;
  roleId?: string;
  forms: {
    [key: string]: formEnum[];
  };
  components: {
    [key: string]: {
      [key: string]: componentScopeEnum[];
    };
  };
  formPage: {
    [key: string]: {
      [key: string]: pageEnum[];
    };
  };
  pages: {
    [key: string]: {
      [key: string]: componentScopeEnum[];
    };
  };
}

export interface ICustomPermissionServer {
  id?: string;
  applicationId: string;
  clientId: string;
  roleId: string;
  forms: {
    [key: string]: {
      [key: string]: formEnum[];
    };
  };
  components: {
    [key: string]: {
      [key: string]: componentScopeEnum[];
    };
  };
  formPage: {
    [key: string]: {
      [key: string]: pageEnum[];
    };
  };
  pages: {
    [key: string]: {
      [key: string]: componentScopeEnum[];
    };
  };
}

export enum formEnum {
  "VIEW_ALL" = "VIEW_ALL",
  "VIEW_OWN" = "VIEW_OWN",
  "VIEW_HIERARCHY" = "VIEW_HIERARCHY",
}
export enum componentScopeEnum {
  "HIDE" = "HIDE",
  "READ" = "READ",
  "WRITE" = "WRITE",
}
export enum pageEnum {
  "HIDE" = "HIDE",
  "SHOW" = "SHOW",
}

export interface IInfographicGridData {
  rowCount: number;
  columnCount: number;
}
export interface IAddInfographicRowAndColumnAction {
  type: string;
  payload: IInfographicGridData;
}
export interface IActiveInfographicAnalytics {
  [formId: string]: IGetFormAnalyticsData;
}
export interface IGetFormAnalyticAction {
  type: string;
  payload: string;
}

export interface IActiveInfographicDataByQuery {
  [widegetId: string]: any;
}
export interface IInfographicMap {
  activeFormInfographic: IInfographicGridData;
  activeInfographicAnalytics: IActiveInfographicAnalytics;
  activeInfographicDataByQuery: IActiveInfographicDataByQuery;
}
export interface IFormsData {
  formIds: string[];
  totalForms: number;
  totalPages: number;
  pageNumber: number;
}

export interface IFormsMap {
  [formId: string]: IFormServer;
}

export interface ILoaders {
  addNewForm: boolean;
  updateForm: boolean;
  deleteForm: boolean;
  fetchForm: boolean;
  fetchFormByIds: boolean;
  duplicateForm: boolean;
  createFormRules: boolean;
  fetchFormRules: boolean;
  updateFormRules: boolean;
  deleteFormRules: boolean;
  fetchInfographicsDashBoardDataById: boolean;
  updateInfographicsDashBoardDataById: boolean;
  addInfographicsDashBoardDataById: boolean;
  deleteInfographicsDashBoardDataByFormId: boolean;
  addFormAnalytics: boolean;
  getFormAnalytics: boolean;
  getInfographicDataByQuery: boolean;
  getSubmissionCount: boolean;
  fetchPermissionById: boolean;
  fetchWorkFlow: boolean;
}

export interface IErrors {
  addNewForm: string;
  updateForm: string;
  deleteForm: string;
  fetchForm: string;
  fetchFormByIds: string;
  duplicateForm: string;
  createFormRules: string;
  fetchFormRules: string;
  updateFormRules: string;
  deleteFormRules: string;
  fetchInfographicsDashBoardDataById: string;
  updateInfographicsDashBoardDataById: string;
  addInfographicsDashBoardDataById: string;
  deleteInfographicsDashBoardDataByFormId: string;
  addFormAnalytics: string;
  getFormAnalytics: string;
  getInfographicDataByQuery: string;
  getSubmissionCount: string;
  fetchPermissionById: string;
  fetchWorkFlow: string;
}

export interface IFetchFormsActionPayload {
  pageNumber: number;
  pageSize: number;
  folderPath: string;
  onFailure: () => void;
  title?: string;
}
export interface IFetchFormsAction {
  type: string;
  payload: IFetchFormsActionPayload;
}

export interface IAddNewFormActionPayload {
  fields: string[];
  subForms: string[];
  title: string;
  folderPath: string;
  templateData?: ITemplate;
}
export interface IFetchFormDatPayload {
  formIds: string[];
  isCurrentForm?: boolean;
}
export interface IFetchFormsByIdsAction {
  type: string;
  payload: IFetchFormDatPayload;
}

export interface IFetchFormsByIdsFreeAction {
  type: string;
  payload: IFetchFormsByIdsFreeActionPayload;
}
export interface IFetchFormsByIdsFreeActionPayload {
  formIds: string[];
  onSuccess: (payload: any) => void;
  onFailure: (payload: any) => void;
}
export interface IFetchPermissionByIdAction {
  type: string;
  payload: string;
  roleName?:string;
}
export interface IAddNewFormAction {
  type: string;
  payload: IAddNewFormActionPayload;
}
export interface IDeleteFormAction {
  type: string;
  payload: number;
}
export interface ITransformAndUpdateFormAction {
  type: string;
  payload: IForm;
}

export interface IUpdateFormAction {
  type: string;
  payload: IFormServer;
}

export interface IFormServer {
  title: string;
  themeId?: string;
  description: string;
  isMultipleForm: boolean;
  subForms: ISubFormServer[];
  formLogo?: string;
  // is not supported by client side
  id?: string;
  createdBy?: string;
  updatedBy?: string;
  name?: string;
  fields?: IFieldServer[];
  // is not supported by server side need to check
  localId?: string;
  settings?: any;
  overviewForm?: any;
  createdDate?: string;
  updatedDate?: string;
  isDisabled?: boolean;
  isMultipleSubAllowed?: boolean;
  sendEmailAlerts?: boolean;
  isAnonymousSubAllowed?: boolean;
  relatedFormIds?: string[];
  isOverviewAllowed?: boolean;
  isDraftViewAllowed?: boolean;
  isApprovalRequired?: boolean;
  isReSubmissionAllowed?: boolean;
  isDeadlineEnabled?: boolean;
  isDynamicDeadlineEnabled?: boolean;
  dynamicDeadlineFieldId?: string;
  approvalFieldId?: string;
  deadlineEndDate?: number;
  deadlineStartDate?: number;
  rules?: IAdvancedRulesClient;
  enableFieldNumbering?: boolean;
  folderPath?: string;
  applicationId?: string;
  environment?: string;
  prefix?: string;
  postfix?: string;
  eyeIcon?: boolean;
  completeEncrypt?: boolean;
  maskChar?: string;
  maxCharacter?: number;
  maskedIndexes?: any;
  sequenceType?: string;
  hideFromVisiblity?: string[];
  generateSequenceByWorkflow?: boolean;
  defaultSequenceValue?: number;
  numericSequenceCount?: number;
  visibility?: visibilityType;
  isCompositeKeyEnabled?: boolean;
  deleteActionRequired?: boolean;
  isReferenceByFieldsMap?: boolean;
  rowActionsRequired?: boolean;
  isSearchRequired?:boolean;
  compositeKeyFields?: any;
  isQrCodeRequired?: boolean;
  qrCodeRefField?: string;
  qrCodeRefPageIds?: string;
  dateRangeEnabled?: boolean;
  isWeekendDisabled?: boolean;
  specificDateSelectionEnabled?: boolean;
  specificDateRangeEnabled?: boolean;
  jsonApiEnabled?: boolean;
  preDisableDateCount?: string;
  postDisableDateCount?: string;
  specificDates?: [];
  specificDateRange?: [];
  dateJsonApiUrl?: string;
  slotDuration?: string;
  slotSetting?: ISlotSetting;
  dateReferralFieldId?: string;
  isPartOfTimeSlot?: boolean;
  isFormLocked?: boolean;
  formLockedBy?: IFormLockedBy;
  templateId?: string;
  isTemplate?: boolean;
  isCurrentDateSelected?: boolean;
  dateInitialValueType?: string;
  isCurrentTimeSelected?: boolean;
  timeInitialValueType?: string;
  isCurrentDateTimeSelected?: boolean;
  dateTimeInitialValueType?: string;
  customSuccessMessage?: string;
  customUpdateSuccessMessage?: string;
  fieldCount?: number;
  isPastDateDisabled?: boolean;
  fromFieldId?: string,
  toFieldId?: string,
  isRegularTimeFormat?: boolean;
  fromTimeFieldId?: string,
  toTimeFieldId?: string,
  isTimeOfDayRequired?: boolean;
  timeOfDayFieldId?: string;
  isMonthDisplayRequired?:boolean;
  monthDisplayFieldId?: string;
  timeOfDayConfig?:ITimeOfDayConfig[];
  isValidationRequiredbeforeSubmission?: boolean,
  isScriptOnFormSubmission?: boolean,
  scriptOnSubmission?: boolean,
  validationModal?: boolean;
  otpModal?: boolean;
  otpMethod?: OtpMethodValue | string;
  otpMethodValue ?: IOption
}
export interface ISubFormServer {
  // not supported by server side need to check
  localId: string;
  title: string;
  fields: IFieldServer[];
  // ot supported by client side
  description?: string;
  number?: number;
  name?: string;
  prefix?: string;
  postfix?: string;
  eyeIcon?: boolean;
  completeEncrypt?: boolean;
  maskChar?: string;
  maxCharacter?: number;
  maskedIndexes?: any;
  sequenceType?: string;
  hideFromVisiblity?: string[];
  generateSequenceByWorkflow?: boolean;
  numericSequenceCount?: number;
  defaultSequenceValue?: number;
  dateRangeEnabled?: boolean;
  isWeekendDisabled?: boolean;
  specificDateSelectionEnabled?: boolean;
  specificDateRangeEnabled?: boolean;
  jsonApiEnabled?: boolean;
  preDisableDateCount?: string;
  postDisableDateCount?: string;
  specificDates?: [];
  specificDateRange?: [];
  dateJsonApiUrl?: string;
  slotDuration?: string;
  slotSetting?: ISlotSetting;
  dateReferralFieldId?: string;
  isPartOfTimeSlot?: boolean;
  isTemplate?: boolean;
  isCurrentDateSelected?: boolean;
  dateInitialValueType?: string;
  isCurrentTimeSelected?: boolean;
  timeInitialValueType?: string;
  isCurrentDateTimeSelected?: boolean;
  dateTimeInitialValueType?: string;
  isPastDateDisabled?: boolean;
  fromFieldId?: string,
  toFieldId?: string,
  isRegularTimeFormat?: boolean;
  fromTimeFieldId?: string,
  toTimeFieldId?: string,
  isTimeOfDayRequired?: boolean;
  timeOfDayFieldId?: string;
  isMonthDisplayRequired?:boolean;
  monthDisplayFieldId?: string;
  timeOfDayConfig?:ITimeOfDayConfig[];
}

export interface IFieldServer {
  id?: string;
  fieldType?: string;
  title?: string;
  element?: string;
  type?: string;
  name?: string;
  description?: string;
  grid?: {
    width?: number;
  };
  isVisible?: boolean;
  isDisabled?: boolean;
  isRequired?: boolean;
  isFocus?: boolean;
  canDelete?: boolean;
  canCopy?: boolean;
  canAdd?: boolean;
  createdDate?: number;
  updatedDate?: number;
  fieldConfig?: IFieldValuesConfigurationServer;
  descriptionType?: descriptionType;
  fields?: any; // added for testing
  localId?: string;
  rules?: any;
  isSection?: boolean;
  enableFieldNumbering?: boolean;
  referenceId?: string;
  prefix?: string;
  postfix?: string;
  eyeIcon?: boolean;
  completeEncrypt?: boolean;
  maskedField?: IMaskedField;
  showVirtualKeyboard?: boolean;
  sequenceType?: string;
  hideFromVisiblity?: string[];
  generateSequenceByWorkflow?: boolean;
  numericSequenceCount?: number;
  defaultSequenceValue?: number;
  dateRangeEnabled?: boolean;
  isWeekendDisabled?: boolean;
  specificDateSelectionEnabled?: boolean;
  specificDateRangeEnabled?: boolean;
  jsonApiEnabled?: boolean;
  preDisableDateCount?: string;
  postDisableDateCount?: string;
  specificDates?: any;
  specificDateRange?: any;
  dateJsonApiUrl?: string;
  slotDuration?: string;
  slotSetting?: ISlotSetting;
  dateReferralFieldId?: string;
  isPartOfTimeSlot?: boolean;
  isTemplate?: boolean;
  isCurrentDateSelected?: boolean;
  dateInitialValueType?: string;
  isCurrentTimeSelected?: boolean;
  timeInitialValueType?: string;
  isCurrentDateTimeSelected?: boolean;
  dateTimeInitialValueType?: string;
  isPastDateDisabled?: boolean;
  fromFieldId?: string,
  toFieldId?: string,
  isRegularTimeFormat?: boolean;
  fromTimeFieldId?: string,
  toTimeFieldId?: string,
  isTimeOfDayRequired?: boolean;
  timeOfDayFieldId?: string;
  isMonthDisplayRequired?:boolean;
  monthDisplayFieldId?: string;
  timeOfDayConfig?:ITimeOfDayConfig[];
}

export type IFieldValuesConfigurationServer =
  | IRatingFieldConfigurationServer
  | ICurrencyFieldConfigurationServer
  | IFileUploadFieldConfigurationServer
  | ILinearScalingFieldConfigurationServer
  | IDropdownFieldConfigurationServer
  | IMultiChoiceFieldConfigurationServer
  | IDatepickerFieldConfigurationServer
  | ITimepickerFieldConfigurationServer
  | ITextInputFieldConfigurationServer
  | INumberInputFieldConfigurationServer
  | IPaymentInputFieldConfigurationServer
  | IDateTimepickerFieldConfigurationServer
  | ICalculativeInputFieldConfigurationServer
  | IDescriptionFieldConfigurationServer
  | ISectionFieldConfigurationServer
  | ICheckBoxFieldConfigurationServer
  | ITextAreaFieldConfigurationServer
  | IFormLookUpConfigurationServer
  | IGeolocationConfigurationServer
  | ISequenceFieldConfigurationServer
  | IPincodeFieldConfigurationServer
  | ITimeSlotFieldConfigurationServer;

export interface IFieldValuesEncriptionDetailsServer {
  options?: string[];
  selected?: string;
}

export interface IFetchFormsSuccessActionPayload {
  content: IFormServer[];
  empty: boolean;
  first: boolean;
  last: boolean;
  numberOfElements: number;
  pageNumber: number;
  pageSize: number;
  totalElements: number;
  totalPages: number;
}

export interface IDuplicateFormAction {
  type: string;
  payload: { formId: string };
}

export interface IDuplicateFormSuccessAction {
  type: string;
  payload: { formData: IFormServer };
}

export interface IDuplicateFormFailureAction {
  type: string;
  payload: { error: string };
}

export interface IRulesMap {
  [formId: string]: IAdvancedRulesServer;
}

export interface IFormLevelRuleClient {
  ruleName?: string;
  logicalOperator?: string;
  conditions?: IFormLevelRuleConditionServer[];
  formConditionIds?: string[];
  formAction?: IFormLevelRuleActionServer[];
  checkFormRuleValidation?: boolean;
  ruleId?: string;
}
export interface IFormLevelRuleConditionServer {
  logicalOperator?: string;
  operator?: string;
  value?: string;
  fieldType?: string;
  fieldLocalId?: string;
  conditions?: IFormLevelRuleConditionServer[];
  formAction?: IFormLevelRuleActionServer[];
}

export interface IFormLevelRuleConditionMap {
  [conditionId: string]: IFormLevelRuleConditionClient;
}
export interface IFormLevelRuleConditionClient {
  formConditionId: string;
  logicalOperator?: string;
  operator?: string;
  value?: string;
  fieldType?: string;
  fieldLocalId?: string;
  conditions?: IFormLevelRuleConditionClient[];
  formConditionIds?: string[];
  conditionName?: string;
  formAction?: IFormLevelRuleActionServer[];
  fieldValueType?: string;
  conditionType?: string;
  isLocalId?: boolean;
}
export interface IFieldLevelRuleConditionMap {
  [conditionId: string]: IFieldLevelRuleConditionClient;
}
export interface IFieldLevelRuleConditionClient {
  fieldConditionId?: string;
  logicalOperator?: string;
  operator?: string;
  value?: any;
  fieldType?: string;
  fieldLocalId?: string;
  subFormLocalId?: string;
  conditions?: IFieldLevelRuleConditionClient[];
  fieldConditionIds?: string[];
  action?: IPageLevelRuleAction;
  conditionName?: string;
  fieldValueType?: string;
  conditionType?: string;
  isLocalId?: boolean;
}
export interface IPageLevelRuleConditionMap {
  [conditionId: string]: IPageLevelRuleConditionClient;
}
export interface IPageLevelRuleConditionClient {
  pageConditionId?: string;
  logicalOperator?: string;
  operator?: string;
  value?: string;
  fieldType?: string;
  fieldLocalId?: string;
  subFormLocalId?: string;
  conditions?: IPageLevelRuleConditionClient[];
  pageConditionIds?: string[];
  conditionName?: string;
  action?: IPageLevelRuleAction;
  fieldValueType?: string;
  conditionType?: string;
  isLocalId?: boolean;
}

export interface IPageLevelRuleAction {
  skip?: IPageLevelRuleActionServer[];
  show?: IPageLevelRuleActionServer[];
  hide?: IPageLevelRuleActionServer[];
  elseSkip?: IPageLevelRuleActionServer[];
}

export interface IPageLevelRuleActionServer {
  subFormLocalId?: string;
}

export interface IRuleActionFieldTypeServer {
  fieldType: string;

  fieldLocalId: string;

  subFormLocalId: string;
}

export interface IDeleteFormRulesActionPayload {
  formRuleData: IAdvancedRulesClient;
  formId: string;
  index: number;
  ruleType: string;
}
export interface IDeleteFormRulesAction {
  type: string;
  payload: IDeleteFormRulesActionPayload;
}
export interface IFetchFormRulesActionPayload {
  formId: string;
}

export interface IFetchFormRulesAction {
  type: string;
  payload: IFetchFormRulesActionPayload;
}

export interface IUpdateFormRuleAction {
  type: string;
  payload: IAdvancedRulesClient;
}

export interface IFetchWorkflowAction {
  type: string;
  payload: IFetchFormRulesActionPayload;
}

export interface IFieldLevelRuleClient {
  ruleName?: string;
  ruleId?: string;
  logicalOperator?: string;
  checkFieldRuleValidation?: boolean;
  conditions?: IFieldLevelRuleConditionClient[];
  action?: IFieldLevelRuleActionServer;
  formAction?: IFormLevelRuleActionServer[];
  fieldConditionIds?: string[];
  fieldsUsedInAction?: string[];
}

export interface IFieldLevelRuleClient1 {
  ruleName?: string;
  ruleId?: string;
  logicalOperator?: string;
  checkFieldRuleValidation?: boolean;
  conditions?: IFieldLevelRuleConditionClient[];
  action?: IFieldLevelRuleActionServer;
  formAction?: IFormLevelRuleActionServer[];
  fieldConditionIds?: string[];
  fieldsUsedInAction?: string[];
}
export interface IRuleActionFieldTypeClient {
  fieldType: string;
  fieldLocalId: string;
  subFormLocalId: string;
  visibility: string;
}

export interface IFieldLevelRuleActionServer {
  show?: IRuleActionFieldTypeServer[];
  hide?: IRuleActionFieldTypeServer[];
  enable?: IRuleActionFieldTypeServer[];
  disable?: IRuleActionFieldTypeServer[];
  setValue?: ISetRuleValueActionFieldTypeServer[];
}
export interface ISetRuleValueActionFieldTypeServer {
  fieldType?: string;
  fieldLocalId?: string;
  subFormLocalId?: string;
  value?: any;
  fromFieldId?: string;
  type?: string;
  aggregateFunction?: aggregateFuntionEnum;
}

export interface IFormLevelRuleActionServer {
  actionType: string;
  value: string;
  emailActionConfig?: IEmailActionConfig;
  smsActionConfig?: ISmsActionConfig;
  whatsAppActionConfig?: IWhatsAppActionConfig;
  redirectActionConfig?: IRedirectActionConfig;
  notificationActionConfig?: INotificationActionConfig;
  mapDataActionConfig?: IMapDataActionConfig;
}
export interface INotificationActionConfig {
  to?: {
    type?: string;
    value?: string;
  };
  body?: string;
}

export interface IMapDataActionConfig {
  selectedFormId?: string;
  fromFieldId?: string;
  toFieldId?: string;
  type?: string;
}
export interface IEmailActionConfig {
  templateType?: string;
  templateId?: string;
  customTemplate?: {
    customTemplateJson?: any;
    customTemplateHtml?: string;
  };
  from?: string;
  to?: ISendToType;
  subject?: string;
  body?: string;
}
export interface ISendToType {
  type?: string;
  value?: string;
}
export interface ISmsActionConfig {
  to?: string;
  body?: string;
}
export interface IWhatsAppActionConfig {
  to?: string;
  body?: string;
}

export interface IRedirectActionConfig {
  type?: string;
  link?: string;
  openIn?: string;
}
export interface IFetchInfographicsDashBoardDataByIdAction {
  type: string;
  payload: string;
}

export interface IInfographicsWidgetDataServer {
  localId?: string;
  row?: number;
  column?: number;
  name?: string;
  description?: string;
  type?: any;
  xAxis?: IWidgetXAxis;
  yAxis?: IWidgetYAxis;
  filterSettings?: IWidgetFilterSettings;
  customizedGraphVisiblity?: boolean;
  title?: string;
  formId?: string;
}
export interface IWidgetYAxis {
  type?: string;
  initialValue?: number;
  perUnit?: number;
}
export interface IWidgetXAxis {
  initialValue?: number;
  perUnit?: number;
}

export interface IWidgetFilterSettings {
  selectFields?: IWidgetSelectedField[];
  conditions?: IWidgetFilterCondition[];
  logicalOperator?: string;
  groupBy?: string[];
  orderBy?: IWidgetFilterOrderBy;
  limit?: IWidgetFilterLimit;
}

export interface IWidgetFilterOrderBy {
  desc: boolean;
  fieldLocalIds: string[];
}

export interface IWidgetFilterLimit {
  start: number;
  end: number;
}

export interface IWidgetFilterCondition {
  fieldTitle?: string;
  fieldLocalId?: string;
  condition?: string;
  value?: any;
  operator: string;
  fieldValueType: string;
  conditionType: string;
  fieldType?: string;
  min?: number;
  max?: number;
}
export interface IWidgetSelectedField {
  fieldTitle?: string;
  fieldLocalId?: string;
  aggregateFunction?: string;
}
export interface IInfographicsDashboardDataServer {
  data?: IInfographicsWidgetDataServer[];
  formId?: string;
  noOfColumns?: number;
  noOfRows?: number;
  dashboardName?: string;
  id?: string;
}

export interface IDashboardDataMap {
  [formId: string]: IInfographicsDashboardDataClient;
}

export interface IUpdateInfographicsDashBoardDataByIdAction {
  type: string;
  payload: IUpdateInfographicsDashBoardDataByIdActionPayload;
}

export interface IUpdateInfographicsDashBoardDataByIdActionPayload {
  infographicsData?: IInfographicsDashboardDataClient;
  formId?: string;
}
export interface IInfographicsDashboardDataClient {
  widgetIds?: string[];
  infographicsWidgetMap?: IInfographicsWidgetMap;
  formId?: string;
  noOfColumns?: number;
  noOfRows?: number;
  dashboardName?: string;
  id?: string;
}

export interface IInfographicQueryData {
  selectFields: IWidgetSelectedField[];
  logicalOperator: string;
  conditions: IWidgetFilterCondition[];
  groupBy: string[];
  orderBy?: IWidgetFilterOrderBy;
  limit?: IWidgetFilterLimit;
}

export interface IInfographicDataByQueryPayload {
  formId: string;
  query: IWidgetFilterSettings;
  widegetId?: string;
  widgetType: "CHART" | "TABLE" | "GRAPH";
}

export interface IFetchInfographicsDataByQueryAction {
  type: string;
  payload: IInfographicDataByQueryPayload;
}
export interface IFetchInfographicsDataByQuerySuucessPayload {
  data: any;
}
export interface IInfographicsWidgetMap {
  [localId: string]: IInfographicsWidgetDataServer;
}

export interface IAddInfographicsDashBoardDataByIdAction {
  type: string;
  payload: IAddInfographicsDashBoardDataByIdActionPayload;
}
export interface IAddInfographicsDashBoardDataByIdActionPayload {
  infographicsData?: IInfographicsDashboardDataClient;
}
export interface IDeleteInfographicsDashBoardDataByFormIdAction {
  type: string;
  payload: string;
}

export enum analyticsKeys {
  NO_OF_RESPONSES = "NO_OF_RESPONSES",
  FORM_VIEWS = "FORM_VIEWS",
  RESPONDED_USERS = "RESPONDED_USERS",
  PAYMENT_ATTEMPTS = "PAYMENT_ATTEMPTS",
  SUCCESSFUL_PAYMENT_ATTEMPTS = "SUCCESSFUL_PAYMENT_ATTEMPTS",
}
export interface IAddFormAnalyticPayload {
  formId: string;
  analyticsKeys: analyticsKeys[];
}
export interface IAddFormAnalyticAction {
  type: string;
  payload: IAddFormAnalyticPayload;
}

export interface IGetFormAnalyticsData {
  formViews: number;
  engagementRate: string;
  paymentAttempts: number;
  respondedUsers: number;
  successfulPaymentAttempts: number;
  noOfResponses: number;
}

export interface IgetSubmissionCountAction {
  type: string;
  payload: string[];
}

export interface ISubmissionCount {
  count: number;
  _id: string;
}

export interface ISubmissionCountMap {
  [formId: string]: ISubmissionCount;
}
export interface IFetchOptionsForLookupFieldWithFilterAction {
  type: string;
  payload: IFetchOptionsForLookupFieldWithFilterActionPayload;
}
export interface IFetchOptionsForLookupFieldAction {
  type: string;
  payload: IFetchOptionsForLookupFieldActionPayload;
}
export interface IConditons {
  fieldTitle: string;
  fieldLocalId: string;
  condition: string;
  value: string;
  fieldValueType: string;
  fieldType?: string;
  conditionType: string;
}
export interface ISelectField {
  fieldTitle: string;
  fieldLocalId: string;
}

export interface IFetchOptionsForLookupFieldWithFilterActionPayload {
  onSuccess: (data: any) => void;
  onFailure: (error: string) => void;
  formId: string;
  fieldIds?: string[];
  query: {
    selectFields?: ISelectField[];
    logicalOperator?: string;
    conditions?: IFieldLevelRuleConditionServer[];
  };
  additionalConditions?: IFieldLevelRuleConditionServer[];
  filterData?: any;
  orgId?: string;
  pageSize?: number;
  pageNumber?: number;
}
export interface IFetchOptionsForLookupFieldActionPayload {
  onSuccess: (data: any) => void;
  onFailure: (error: string) => void;
  formId: string;
  fieldIds?: string[];
  filterData: any;
}
export interface ISubmissionLevelRuleActionServer {
  actionType?: string;
  value?: string;
}
export interface ISubmissionLevelRuleClient {
  ruleName?: string;
  logicalOperator?: string;
  conditions?: ISubmissionLevelRuleConditionServer[];
  submissionConditionIds?: string[];
  submissionAction?: ISubmissionLevelRuleActionServer;
  checkSubmissionRuleValidation?: boolean;
  ruleId?: string;
}

export interface ISubmissionLevelRuleConditionServer {
  logicalOperator?: string;
  operator?: string;
  value?: string;
  fieldType?: string;
  fieldLocalId?: string;
  conditions?: ISubmissionLevelRuleConditionServer[];
  submissionAction?: ISubmissionLevelRuleActionServer;
}

export interface ISubmissionLevelRuleConditionClient {
  submissionConditionId?: string;
  logicalOperator?: string;
  operator?: string;
  value?: string;
  fieldType?: string;
  fieldLocalId?: string;
  conditions?: ISubmissionLevelRuleConditionClient[];
  submissionConditionIds?: string[];
  conditionName?: string;
  submissionAction?: ISubmissionLevelRuleActionServer;
  fieldValueType?: string;
  conditionType?: string;
  isLocalId?: boolean;
}

export interface ISubmissionLevelRuleConditionMap {
  [conditionId: string]: ISubmissionLevelRuleConditionClient;
}

export interface IDoublePanelLevelRuleClient {
  ruleName?: string;
  logicalOperator?: string;
  conditions?: ISubmissionLevelRuleConditionServer[];
  submissionConditionIds?: string[];
  submissionAction?: ISubmissionLevelRuleActionServer;
  checkSubmissionRuleValidation?: boolean;
  ruleId?: string;
}
